// extracted by css-extract-rspack-plugin
export default {"settingDescriptionList":"settingDescriptionList-Mg7paW","backButton":"backButton-sgsivb"};